<template lang="pug">
v-row
  v-col
    textarea(
      id="editor",
      v-model="content"
    )
</template>

<script>
import * as CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/htmlembedded/htmlembedded.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/keymap/sublime.js'

import 'codemirror/addon/edit/closebrackets.js'
import 'codemirror/addon/edit/closetag.js'

export default {
  name: "code-editor",
  props: {
    value: {
      type: String
    },
    language: {
      type: String,
      default: 'javascript'
    }
  },
  data() {
    return {
      content: '',
      codemirrorInstance: null
    }
  },
  methods: {
    initEditor() {
      this.codemirrorInstance = CodeMirror.fromTextArea(document.getElementById("editor"), {
        lineNumbers: true,
        mode: this.language,
        tabSize: 2,
        keyMap: 'sublime',
        autoCloseTags: true,
        autoCloseBrackets: true,
        extraKeys: {
          "Tab": function(cm){
            cm.replaceSelection("  " , "end");
          }
        }
      });

      this.codemirrorInstance.setValue(this.value || "")
      
      this.codemirrorInstance.on('change', cm => {
        this.content = cm.getValue();
        this.$emit('input', this.content);
      });
    },
  },
  mounted() {
    this.initEditor();
  },
  created() {
    this.content = this.value;
  },
};
</script>

<style>
.CodeMirror {
  /* Set height, width, borders, and global font properties here */
  font-family: monospace;
  height: 600px;
  color: black;
  direction: ltr;
  font-size: 18;
}
</style>